import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Siamo spiacenti che l\'articolo non sia stato d\'aiuto. Vuoi farci sapere cosa c\'è che non va?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Mancano le informazioni che cerco',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Ci sono errori di fatto',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Alcuni problemi non sono chiari',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Dacci qualche dettaglio e miglioreremo questo articolo.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Invia'
    }
  }
};